import type React from 'react';

import type { IconProps } from 'types/icon';

const Email: React.FC<IconProps> = ({
  size = '20',
  color = 'currentColor',
  ...attributes
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...attributes}
    >
      <path
        d="M21.25 26.5625H8.75C4.1875 26.5625 1.5625 23.9375 1.5625 19.375V10.625C1.5625 6.0625 4.1875 3.4375 8.75 3.4375H21.25C25.8125 3.4375 28.4375 6.0625 28.4375 10.625V19.375C28.4375 23.9375 25.8125 26.5625 21.25 26.5625ZM8.75 5.3125C5.175 5.3125 3.4375 7.05 3.4375 10.625V19.375C3.4375 22.95 5.175 24.6875 8.75 24.6875H21.25C24.825 24.6875 26.5625 22.95 26.5625 19.375V10.625C26.5625 7.05 24.825 5.3125 21.25 5.3125H8.75Z"
        fill={color}
      />
      <path
        d="M14.9997 16.0875C13.9497 16.0875 12.8872 15.7625 12.0747 15.1L8.16222 11.975C7.76222 11.65 7.68723 11.0625 8.01223 10.6625C8.33723 10.2625 8.92473 10.1875 9.32473 10.5125L13.2372 13.6375C14.1872 14.4 15.7997 14.4 16.7497 13.6375L20.6622 10.5125C21.0622 10.1875 21.6622 10.25 21.9747 10.6625C22.2997 11.0625 22.2372 11.6625 21.8247 11.975L17.9122 15.1C17.1122 15.7625 16.0497 16.0875 14.9997 16.0875Z"
        fill={color}
      />
    </svg>
  );
};

export default Email;
